import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import sparkles from '@starbucks-web/pattern-library/lib/icons/sparkles';

import { cardTermsAndConditionsUrlSelector } from 'shared/app/state/selectors/privacy-and-terms';
import ExternalLink from 'shared/app/components/external-link';

import { svcMessages } from 'shared/app/messages/svc-cards';
import messages from '../../messages';

import styles from './styles.cssm';

export const TermsAndConditions = () => {
  const cardTermsAndConditionsUrl = useSelector(
    cardTermsAndConditionsUrlSelector
  );

  const { formatMessage } = useIntl();

  return (
    <div className={`${styles.termsContainer} bg-ceramic`}>
      <ContentColumn className="mx-auto" size="lg">
        <div className="flex py3">
          <Icon className="color-gold mr2" path={sparkles} />
          <p className="color-textBlackSoft">
            {formatMessage(messages.termsAndConditionsAgreement)}
          </p>
        </div>
        <ExternalLink
          className="ml5"
          href={cardTermsAndConditionsUrl}
          visualStyle="button"
        >
          {formatMessage(svcMessages.cardTermsAndConditionsLink)}
        </ExternalLink>
      </ContentColumn>
    </div>
  );
};

export default TermsAndConditions;
